import { Component, Input, OnChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IFrameOfferPayload } from '../../models/model';

@Component({
standalone: false,
  selector: 'app-iframe-offer',
  styleUrls: ['./iframe-offer.component.scss'],
  templateUrl: './iframe-offer.component.html',
})
export class IframeOfferComponent implements OnChanges {
  @Input() public payload: IFrameOfferPayload;

  public safeIFrameUrl: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}

  public ngOnChanges(): void {
    this.safeIFrameUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.payload.iframeUrl);
  }
}
